import { Component, Input } from '@angular/core';
import { EmploymentStatus } from '../employment-status';

@Component({
  selector: 'app-employment-status-form',
  templateUrl: 'form.component.html',
})
export class EmploymentStatusFormComponent {
  @Input() employmentStatus: EmploymentStatus;
}
